import { GovernanceCommunityAccount, GovernanceCommunityData } from '@/api/addressFormula/interface'
import MePagination from '@/components/MePagination'
import GovListCard from './card'
import styles from './index.module.less'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { useRequest } from 'ahooks'
import { getRestAccountGovernanceAddress } from '@/api/addressFormula'
import LoadingCom from '@/components/LoadingCom'
const GovList = () => {
  const { t } = useTranslation()
  const [govList, setGovList] = useState<GovernanceCommunityAccount[]>([])
  const [pageParams, setPageParams] = useState<{
    offset: number
    limit: number
    page: number
  }>({
    offset: 0,
    limit: 10,
    page: 1,
  })
  const [total, setTotal] = useState(0)
  // 全网治理地址
  const { loading } = useRequest(
    () =>
      getRestAccountGovernanceAddress({
        limit: pageParams.limit,
        offset: pageParams.offset,
      }),
    {
      refreshDeps: [pageParams],
      onSuccess: (res: GovernanceCommunityData) => {
        if (res) {
          setGovList(res.governance_community_accounts)
          setTotal(res.governance_community_accounts_aggregate.aggregate.count)
        }
      },
    },
  )

  return (
    <div className={styles.govListWrapBox}>
      {loading && <LoadingCom />}
      <div className={styles.govListTitle}>{t('explorer_232')}</div>
      <div className={styles.govListWrap}>
        {govList.map((item, index) => (
          <GovListCard
            key={item.address}
            address={item.address}
            index={index}
            page={pageParams.page}
          ></GovListCard>
        ))}
      </div>
      <div className={'footer_pagination'}>
        <MePagination
          currentPage={pageParams.page}
          pageSize={pageParams.limit}
          setPageParams={setPageParams}
          total={total}
        ></MePagination>
      </div>
    </div>
  )
}

export default GovList
